// try ... catch здесь нужен, потому что браузеры могут блокировать доступ к window.top из-за same origin policy
export var isInIframe = function () {
    try {
        return window.self !== window.top;
    }
    catch (e) {
        return true;
    }
};
//# sourceMappingURL=browser.js.map